import $ from 'jquery';

export default class Navigation {
  constructor(instance) {
    this.$el = $(instance.el);
    this.$document = $(document.body);
    this.dropdownToggle = '[data-dropdown-toggle]';
    this.primaryLinks = this.$el[0].querySelectorAll('[data-primary-link]');
    this.secondaryLinks = this.$el[0].querySelectorAll('[data-secondary-link]');

    $('[data-dropdown-toggle]').on('click.navigation', event => this.toggleNavigation(event));
    $('[data-dropdown-toggle]').on('keydown.navigation', event => this.toggleNavigationByKey(event));

    // Click

    this.$el.on('click.navigation', () => {
      if (!$(event.target).closest('.navigation').length) {
        $('.navigation .open').removeClass('open');
      }
    });

    this.$el.on('click.navigation', '.has-dropdown > .header-navigation-link', e => {
      const $target = e.currentTarget;
      this.setMenuLink($target, e);
    });

    // Touch

    this.$document.on('touchend', () => {
      this.closePrimaryMenus();
      this.closeSecondaryMenus();
    });

    this.$el.on('touchend.navigation', '.has-dropdown > details.header-navigation-link', e => {
      const $target = e.currentTarget;
      $target.focus();
      e.preventDefault();
      this.setMenuLink($target, e);
      this.openMenu($target, e);
    });

    this.$el.on('touchend.navigation', '.has-dropdown > a.header-navigation-link', e => {
      const $target = e.currentTarget;
      $target.focus();
      this.setMenuLink($target, e);
      this.openMenu($target, e);
    });

    // Focus

    this.$el.on('focus.navigation', '.has-dropdown > .header-navigation-link', () => {
      const $target = $(event.currentTarget).parent('li');
      this.closeTierMenus($target);
    });

    // Mouseover

    this.$el.on('mouseover.navigation', '.has-dropdown > .header-navigation-link', e => {
      const $target = e.currentTarget;
      this.closePrimaryMenus();
      this.openMenu($target, e);
    });

    // Mouseleave

    this.$el.on('mouseleave.navigation', '.header-navigation-list', () => {
      this.closePrimaryMenus();
    });

    this.$el.on('mouseleave.navigation', '.has-dropdown > .secondary-link', () => {
      this.closeSecondaryMenus();
    });
  }

  setMenuLink($target, e) {
    e.stopPropagation();
    const clickedParent = $target.classList.contains('primary-link') || $target.classList.contains('secondary-link');
    // When the dropdown menu is open, redirect parent links
    if (clickedParent && $target.open === true && $target.getAttribute('href')) {
      window.location = $target.getAttribute('href');
    }
  }

  // Open

  openMenu($target) {
    $target.open = true;
  }

  // Close

  closePrimaryMenus() {
    this.primaryLinks.forEach(primaryLinks => {
      primaryLinks.open = false;
    });
  }

  closeSecondaryMenus() {
    this.secondaryLinks.forEach(secondaryLinks => {
      secondaryLinks.open = false;
    });
  }

  closeSiblingMenus($targetLi) {
    const $siblingMenuParents = $targetLi.siblings('.open');
    this.closeMenus($siblingMenuParents);
  }

  closeTierMenus($target) {
    const $openMenus = $target.parent().find('.open');

    if (!$openMenus.length) { return; }

    this.closeMenus($openMenus);
  }

  closeMenus($menusParents) {
    $menusParents.each((index, menuParent) => {
      const $menuParent = $(menuParent);
      const $toggle = $menuParent.closest(this.dropdownToggle);

      $menuParent.removeClass('open');
      this.toggleMenuButton($toggle, false);
    });
  }

  // Toggle

  toggleMenuButton($button, state) {
    $button.attr('aria-expanded', state);
  }

  toggleNavigationByKey(event) {
    if (event.keyCode !== 13) { return; }
    this.toggleNavigation(event);
  }

  toggleNavigation(event) {
    const $toggle = $(event.currentTarget);
    const $parent = $toggle.parent('.has-dropdown');
    const menuIsOpen = $parent.hasClass('open');
    this.closeSiblingMenus($parent);
    this.toggleMenuButton($toggle, !menuIsOpen);
    event.preventDefault();
    $parent.toggleClass('open');
  }

  unload() {
    $('[data-dropdown-toggle]').off('.navigation');
    this.$el.off('.navigation');
  }
}
